import { Button } from '@cleartax/wg-library-button';
import { useApi } from '@cleartax/wg-library-hooks';
import { Text } from '@cleartax/wg-library-typography';
import { forwardRef, useEffect, useState } from 'react';
import { trackAction } from '../../../../../../../shared';
import { getReviews } from '../../../../api/index.api';
import { usePlanCtx } from '../../../planDetailsContext';
import { SectionConatiner } from '../../ui-blocks/containers';
import { SectionHeading } from '../../ui-blocks/typograpghy';
import { ISection } from '../types';
import { ReviewCarousel } from './review-carousel/index.component';
import { ReviewModal } from './review-modal/reviewModal.component';
import { IReview } from './types';
export const Review: React.FC<ISection> = forwardRef(
  ({ id, name }, ref: React.ForwardedRef<HTMLDivElement>) => {
    const planDetails = usePlanCtx();
    const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
    const reviewApi = useApi<IReview[]>([], getReviews, true);
    const { planId } = planDetails;

    useEffect(() => {
      reviewApi.request(planId);
    }, []);

    const handleReviewButtonClick = () => {
      setIsReviewModalOpen(true);
      trackAction('click', '', { label: 'popup_open_write_review' });
    };

    return (
      <div id={id} ref={ref} className="relative">
        <SectionConatiner border={false}>
          <SectionHeading>{name}</SectionHeading>
          <Text className="text-grey-500 mt-4" textSize="sm">
            Average Rating
          </Text>
          <div className="flex mt-1">
            <Text textSize="2xl" className="text-brand-1000" weight="bold">
              {planDetails.rating}
            </Text>
            <Text
              mergeClasses="override"
              className="icon-star-full text-[#fbaa39] text-s-18 ml-1 mt-1"
            ></Text>
          </div>
          {!reviewApi.isLoading && reviewApi.data ? (
            <div className="relative">
              {' '}
              <ReviewCarousel reviews={reviewApi.data} />
            </div>
          ) : null}
          <div className="sm:absolute sm:right-0 sm:top-0">
            <Button
              variant="blue"
              className="mt-5"
              rounded="lg"
              onClick={() => handleReviewButtonClick()}
            >
              Write a review
            </Button>
          </div>
          <ReviewModal
            isOpen={isReviewModalOpen}
            onClose={() => setIsReviewModalOpen(false)}
          />
        </SectionConatiner>
      </div>
    );
  }
);

Review.displayName = 'Review';
